// lbl.home
export const register = {
    title: "Hello World!",
    register: "สมัครสมาชิก",
    please_enter_id: "กรุณากรอกข้อมูลให้ครบถ้วน",
    confirm: 'ยืนยัน',
    nationality: {
        name: 'สัญชาติ',
        placeholder: '',
        required: '',
        too_short: '',
        invalid: '',
    },
    id_card: {
        name: 'รหัสบัตรประชาชน',
        placeholder: 'กรุณากรอกรหัสบัตรประชาชน 13 หลัก',
        required: '',
        too_short: '',
        invalid: 'รหัสบัตรประชาชน 13 หลักไม่ถูกต้อง',
    },
    passport: {
        name: 'หมายเลข Passport',
        placeholder: 'กรุณากรอกหมายเลข Passport',
        required: '',
        too_short: '',
        invalid: '',
    },
    mobile: {
        name: 'เบอร์โทรศัพท์',
        placeholder: 'xxx-xxx-xxxx',
        required: 'กรุณากรอก เบอร์โทรศัพท์',
        too_short: 'กรุณากรอกเบอร์โทร 10 หลัก',
        invalid: '',
    },
    login:{
        registerText: 'ลงทะเบียน',
        loginText: 'เข้าสู่ระบบ'
    },
    menu:{
        main: 'หน้าหลัก',
        privilege: 'สิทธิพิเศษ',
        mission: 'ภารกิจ'
    },
    form: {
        title: 'สมัครสมาชิก',
        requireText: 'กรุณากรอกข้อมูลของท่าน',
        nationalIdCard: {
            name: 'รหัสบัตรประชาชน',
            placeholder: 'รหัสบัตรประชาชน',
            required: 'กรุณากรอกเลขบัตรประชาชน',
            too_short: 'กรุณากรอกเลขบัตรประชาชน 13 หลัก',
            invalid: 'เลขบัตรประชาชนไม่ถูกต้อง',
        },
        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        phone: {
            name: 'เบอร์โทรศัพท์',
            placeholder: 'เบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: '',
            invalid: '',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'รูปแบบอีเมลไม่ถูกต้อง',
        },
        gender: {
            name: 'เพศ',
            placeholder: 'เพศ',
            required: 'กรุณาเลือกเพศ',
            too_short: '',
            invalid: '',
        },
        passwordFormat: {
            name: 'รูปแบบรหัสผ่าน',
            placeholder: 'รูปแบบรหัสผ่าน',
            required: 'กรุณาเลือกรูปแบบรหัสผ่าน',
            too_short: '',
            invalid: '',
        },
        password: {
            name: 'รหัสผ่าน',
            placeholder: 'รหัสผ่าน',
            required: 'กรุณาระบุรหัสผ่าน',
            too_short: 'กรุณาระบุรหัสผ่าน 8-20 ตัวอักษร',
            invalid: '',
        },
        passwordConfirm: {
            name: 'ยืนยันรหัสผ่าน',
            placeholder: 'ยืนยันรหัสผ่าน',
            required: 'กรุณายืนยันรหัสผ่าน',
            too_short: 'กรุณาระบุรหัสผ่าน 8-20 ตัวอักษร',
            invalid: '',
        },
        passwordNotRequire: {
            name: 'รหัสผ่าน',
            placeholder: 'รหัสผ่าน',
            required: '',
            too_short: 'กรุณาระบุรหัสผ่าน 8-20 ตัวอักษร',
            invalid: '',
            desc1: 'รหัสผ่านประกอบด้วย 8-20 ตัวอักษร',
            desc2: 'โดยต้องใช้อักษรตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่ และตัวเลข',
        },
        passwordConfirmNotRequire: {
            name: 'ยืนยันรหัสผ่าน',
            placeholder: 'ยืนยันรหัสผ่าน',
            required: '',
            too_short: 'กรุณาระบุรหัสผ่าน 8-20 ตัวอักษร',
            invalid: '',
            desc1: 'รหัสผ่านประกอบด้วย 8-20 ตัวอักษร โดยต้องใช้',
            desc2: 'อักษรตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่ และตัวเลข',
        },
        pin: {
            name: 'PIN Code',
            placeholder: 'PIN Code',
            required: 'กรุณาระบุ PIN Code',
            too_short: 'กรุณาระบุ PIN Code 8 หลัก',
            invalid: '',
            desc: 'รหัสผ่านประกอบด้วยตัวเลข 0-9 จำนวน 8 ตัว',
        },
        pinConfirm: {
            name: 'ยืนยัน PIN Code',
            placeholder: 'ยืนยัน PIN Code',
            required: 'กรุณายืนยัน PIN Code',
            too_short: 'กรุณาระบุ PIN Code 8 หลัก',
            invalid: '',
        },
        pinNoteRequire: {
            name: 'PIN Code',
            placeholder: 'PIN Code',
            required: '',
            too_short: 'กรุณาระบุ PIN Code 8 หลัก',
            invalid: '',
            helpText: 'รหัสผ่านประกอบด้วยตัวเลข 0-9 จำนวน 8 ตัว',
        },
        pinConfirmNoteRequire: {
            name: 'ยืนยัน PIN Code',
            placeholder: 'ยืนยัน PIN Code',
            required: '',
            too_short: 'กรุณาระบุ PIN Code 8 หลัก',
            invalid: '',
            helpText: 'รหัสผ่านประกอบด้วย 8-20 ตัวอักษร โดยต้องใช้ อักษร ตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่ และตัวเลข',
        },
        passwordFormatText: 'รหัสผ่านประกอบด้วย 8-20 ตัวอักษร โดยต้องใช้อักษร ตัวพมพ์เล็ก ตัวพิมพ์ใหญ่ และตัวเลข',
        confirm: 'ยืนยัน',
        acceptTerm: 'ฉันเห็นด้วยกับ',
        acceptTermUrl: 'ข้อกำหนดและเงื่อนไข และ ความเป็นส่วนตัวของข้อมูล',
        loading_register: 'กำลังตรวจสอบข้อมูลประกันของท่าน',

    },
    no_data: 'ไม่พบข้อมูล !',
    title_point_modal: "ขอบคุณสำหรับการลงทะเบียน",
    title2_point_modal: "จากแต้มพิเศษ เพื่อนำไปใช้แลกสิทธิพิเศษต่างๆ",
    title3_point_modal: "จากการเป็นลูกค้าที่มีกรมธรรม์พร้อมแต้มพิเศษ เพื่อนำไปใช้แลกสิทธิพิเศษต่างๆ",
    you_get: "คุณได้รับ",
    text_register_1: 'เนื่องจากคุณยังไม่ได้เป็นลูกค้าทิพยประกันภัย </br> จึงยังไม่สามารถเข้าใช้งานระบบนี้ได้',
    text_register_2: 'คุณสามารถแลกสิทธิพิเศษกับทิพยประกันภัยได้ที่',
    goto_register_tip: 'Go to TIP Society Website',
    unregister: 'ยังไม่ได้เป็นสมาชิก กรุณาลงทะเบียนก่อนเข้าใช้งาน',
    title_terms: 'แบบฟอร์มการให้ความยินยอมในการเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคล',
    title_terms2: 'การดำเนินกิจกรรมส่งเสริมการขาย นโยบายการเปิดเผยข้อมูลส่วนบุคคลต่อบริษัท',
};
